import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const AreasOfActivity = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2
      }
    );

    const currentElement = sectionRef.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, []);

  const areas = [
    {
      key: 'textile',
      image: "/images/4.jpg",
      path: "/tekstil"
    },
    {
      key: 'packaging',
      image: "/images/2.jpg",
      path: "/ambalaj"
    },
    {
      key: 'trade',
      image: "/images/3.jpg",
      path: "/ticaret"
    }
  ];

  return (
    <section 
      className="py-20 relative" 
      id="faaliyet"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 w-full h-full bg-cover bg-center"
        style={{ 
          backgroundImage: 'url(/images/bgnavy.png)',
        }}
      />
      
      {/* Content */}
      <div 
        ref={sectionRef}
        className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 opacity-0 transition-opacity duration-1000 ease-out"
      >
        <div className="flex items-center justify-center mb-5">
          <div className="w-4 h-4 rounded-full bg-primaryBlue flex-shrink-0"></div>
          <h6 className="text-md font-medium text-white ltr:ml-2 rtl:mr-2">{t('activities.subtitle')}</h6>
        </div>
        {/* Section Title */}
        <h2 className="text-4xl font-semibold text-white text-center mb-12">
          {t('activities.title')}
        </h2>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {areas.map((area) => (
            <Link 
              key={area.key}
              to={area.path}
              className="relative h-[400px] group overflow-hidden rounded-2xl transition-transform duration-300 hover:scale-[1.02]"
            >
              {/* Background Image */}
              <div 
                className="absolute inset-0 w-full h-full bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                style={{ 
                  backgroundImage: `url(${area.image})`,
                }}
              />
              {/* Dark Overlay */}
              <div className="absolute inset-0 bg-black opacity-20 group-hover:opacity-30 transition-opacity duration-300"></div>
              
              {/* Content */}
              <div className="relative h-full flex flex-col justify-end p-6 text-white">
                <h3 className="text-xl font-semibold mb-2">{t(`activities.areas.${area.key}.title`)}</h3>
                <p className="text-sm text-gray-200 opacity-90">{t(`activities.areas.${area.key}.description`)}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AreasOfActivity; 